import { useEffect, useState } from 'react'
import { ComparativeSalesChart } from '../components/comparative-sellers/comparative-sales-chart'
import { ComparativeSellerSelector } from '../components/comparative-sellers/comparative-seller-selector'
import type { ComparativeSeller } from '../types/comparative-report.type'

export default function ComparitiveSellersInterface({
  sellers,
  enabled = true,
}: { sellers: ComparativeSeller[]; enabled?: boolean }) {
  // null represents "all", including sellers returned by a new period.
  const [selection, setSelection] = useState<number[] | null>(null)

  useEffect(() => {
    if (!enabled) return
    setSelection((previous) => {
      if (previous === null) return null
      const available = new Set(sellers.map((seller) => seller.fkVendedor))
      const next = previous.filter((id) => available.has(id))
      return next.length === previous.length ? previous : next
    })
  }, [sellers, enabled])

  const filteredSellers =
    selection === null
      ? sellers
      : sellers.filter((seller) => selection.includes(seller.fkVendedor))

  return (
    <div className="space-y-4" hidden={!enabled || sellers.length === 0}>
      <ComparativeSellerSelector
        sellers={sellers}
        selectedIds={filteredSellers.map((seller) => seller.fkVendedor)}
        onChange={setSelection}
      />
      <ComparativeSalesChart sellers={filteredSellers} />
    </div>
  )
}
